import React from "react";
import "./AuditionStarStatus.css";
import Status2 from "./StatusCom/Status2";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import star from "../../../../assets/images/Rounds/Star.png";
import icon2 from "../../../../assets/images/Rounds/icons/finish 1.png";
import icon3 from "../../../../assets/images/Rounds/icons/flag 1.png";
import noImage from "../../../../assets/images/settings/no-image.png";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import MakePostContent from "../../MakePostContent/MakePostContent";
import { serverInfo } from "../../../../App";
import { useContext } from "react";

const AuditonStarStatus = (props) => {

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const {
    audition,
    auditionRoundRule,
    auditionJudgeInstructions,
    activeAuditionJudgeInstructionId,
    isAllStarResponsed,
    data,
    setData,
    isAlreadySubmitted,
  } = props;
  const [checkData, setCheckData] = React.useState(
    activeAuditionJudgeInstructionId
  );
  const [singleAuditionInstruction, setSingleAuditionInstruction] =
    React.useState({});

  const checkDataHandler = (data) => {
    setCheckData(data);
    getSingleAuditionInstructionSecondTime(data);
  };

  const getSingleAuditionInstruction = () => {
    axios
      .get(
        `/api/audition-admin/audition/singleAuditionInstruction/${checkData}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setSingleAuditionInstruction(res.data.auditionJudgeInstruction);
        }
      });
  };
  const getSingleAuditionInstructionSecondTime = (data) => {
    axios
      .get(`/api/audition-admin/audition/singleAuditionInstruction/${data}`)
      .then((res) => {
        if (res.data.status === 200) {
          setSingleAuditionInstruction(res.data.auditionJudgeInstruction);
        }
      });
  };

  useEffect(() => {
    getSingleAuditionInstruction();
  }, []);

  return (
    <div className="my-2">
      <div className="accordion" id="accordionExample">
        <div
          className="accordion-item mb-1"
          style={{ border: "none", outline: "none" }}
        >
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button accordionHeader text-light"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              style={{ boxShadow: "none" }}
            >
              Start status
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body bg-dark">
              {/* <Status /> */}
              <div>
                <div className="d-flex justify-content-between flex-wrap">
                  <div
                    className=""
                    style={{
                      height: "200px",
                      width: "230px",
                      borderRadius: "20px",
                    }}
                  >
                    <img src={star} alt="" className="h-100 w-100" />
                  </div>
                  {audition.assigned_judges &&
                    audition?.assigned_judges.map((judge, index) => (
                      <div
                        className={
                          checkData === judge.judge_instruction.id
                            ? "card bg-warning"
                            : "card star-cardColor"
                        }
                        style={{
                          height: "200px",
                          width: "230px",
                          borderRadius: "20px",
                        }}
                      >
                        <div
                          className="card-body"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            checkDataHandler(judge.judge_instruction.id)
                          }
                        >
                          <div className="d-flex justify-content-start">
                            {judge.user ? (
                              <small className="text-bold text-light">
                                {judge.user.first_name +
                                  " " +
                                  judge.user.last_name}
                              </small>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="d-flex justify-content-end">
                            {judge.judge_instruction ? (
                              <small className="text-bold star-pendingColor">
                                {judge.judge_instruction.status === 0
                                  ? "Pending"
                                  : judge.judge_instruction.status === 1
                                    ? "Accpted"
                                    : null}
                                *
                              </small>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="text-center d-flex justify-content-center">
                            <img
                              src={
                                judge.user.image
                                  ? imageCdnUrl + judge.user.image
                                  : noImage
                              }
                              style={{
                                height: "100px",
                                width: "100px",
                                borderRadius: "50%",
                              }}
                              alt="Star"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="container my-3">
                  <div
                    style={{ border: "2px solid gold", borderRadius: "10px" }}
                  >
                    <div className="p-4">
                      <h5 className="text-warning">Title</h5>
                      <div className="card star-cardColor2">
                        <div className="card-body ">
                          <p className="text-light">
                            {singleAuditionInstruction &&
                              singleAuditionInstruction.title}
                          </p>
                        </div>
                      </div>

                      <div className="mt-4">
                        <h5 className="text-warning">Instructions</h5>
                        <div>
                          {singleAuditionInstruction && (
                            <Markup
                              className="text-light"
                              content={singleAuditionInstruction.description}
                            />
                          )}
                        </div>
                      </div>

                      <div className="container topBannerVideoRound">
                        <img
                          src={
                            singleAuditionInstruction.banner
                              ? imageCdnUrl + singleAuditionInstruction.banner
                              : noImage
                          }
                          alt=""
                          className="img-fluid w-100"
                        />
                      </div>

                      <div className="container topBannerVideoRound my-4">
                        {/* <img
                          src={topvideoBanner}
                          alt=""
                          className="img-fluid w-100"
                        /> */}

                        <ReactPlayer
                          url={
                            singleAuditionInstruction.video
                              ? videoCdnUrl + singleAuditionInstruction.video
                              : "https://youtu.be/dgfTiONcnTc"
                          }
                          playing={false}
                          volume={1}
                          width="100%"
                          controls="true"
                          autoplay
                        />
                      </div>

                      <section className="container d-sm-block d-md-flex justify-content-between">
                        <div className="status-start d-flex mb-2">
                          <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                            <div>
                              <img src={icon3} className="statusImg" alt="" />
                            </div>
                          </div>
                          <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                            <div>
                              <small className="text-light">Starts</small>
                              <h5 className="text-light fontSizeStatus">
                                {moment(audition.start_time).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>

                        <div className="status-start2 d-flex mb-2">
                          <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                            <div>
                              <img src={icon2} className="statusImg" alt="" />
                            </div>
                          </div>
                          <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                            <div>
                              <small className="text-light">Ends</small>
                              <h5 className="text-light fontSizeStatus">
                                {" "}
                                {moment(audition.end_time).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="accordion-item"
          style={{ border: "none", outline: "none" }}
        >
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button accordionHeader  collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              style={{ boxShadow: "none" }}
            >
              Create Event for first round.
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body bg-dark">
              <Status2
                audition={audition}
                auditionRoundRule={auditionRoundRule}
                isAllStarResponsed={isAllStarResponsed}
                data={data}
                setData={setData}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Notun Kaaaj */}
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Registration Forum for User</Accordion.Header>
          <Accordion.Body>
            <MakePostContent />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default AuditonStarStatus;
